import React from 'react';

const TwitchLogo = (props) => {
	return (
		<div class="twitch_logo">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<polygon points="6,8.25 6,21.75 10.5,21.75 10.5,25.5 14.25,21.75 17.25,21.75 24,15 24,4.5 9.75,4.5"/>

				<path class="force_color" fill='#FFFFFF' d="M10.5,17.25h3v3l3-3h3l3-3V6h-12V17.25z M18.75,9h1.5v4.5h-1.5V9z M15,9h1.5v4.5H15V9z"/>
			</svg>
		</div>
	)
}

export default TwitchLogo;